/** Shared elevation / 3D chrome for dashboard cards & panels */

export const dashboardCardShadow =
  "0 2px 4px rgba(15, 23, 42, 0.04), 0 8px 18px rgba(15, 23, 42, 0.08), 0 1px 0 rgba(255,255,255,0.8) inset";

export const dashboardCardHoverShadow =
  "0 10px 24px rgba(210, 54, 58, 0.16), 0 4px 10px rgba(15, 23, 42, 0.1), 0 1px 0 rgba(255,255,255,0.9) inset";

export const dashboardPanelShadow =
  "0 2px 6px rgba(15, 23, 42, 0.04), 0 14px 32px rgba(15, 23, 42, 0.08), 0 1px 0 rgba(255,255,255,0.9) inset";

export const dashboardPanelHoverShadow =
  "0 6px 14px rgba(210, 54, 58, 0.1), 0 18px 40px rgba(15, 23, 42, 0.1), 0 1px 0 rgba(255,255,255,0.95) inset";

/** Soft panel: tables / large shells — lift without aggressive tilt */
export const dashboardPanelSx = {
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  backgroundColor: "#ffffff",
  boxShadow: dashboardPanelShadow,
  transformStyle: "preserve-3d" as const,
  transition:
    "box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1), transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.25s ease",
  "@keyframes dashboardPanelIn": {
    from: {
      opacity: 0,
      transform: "translateY(10px) rotateX(4deg)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0) rotateX(0deg)",
    },
  },
  animation: "dashboardPanelIn 560ms cubic-bezier(0.22, 1, 0.36, 1) both",
  "&:hover": {
    boxShadow: dashboardPanelHoverShadow,
    borderColor: "#e0e2e7",
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
  },
};

/** Interactive small cards (inventory status, chart tiles) */
export const dashboardInteractiveCardSx = (opts?: {
  accentBorder?: string;
  clickable?: boolean;
}) => {
  const accent = opts?.accentBorder;
  const clickable = opts?.clickable ?? true;
  return {
    borderRadius: "12px",
    border: accent ? `1.5px solid ${accent}` : "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
    boxShadow: dashboardCardShadow,
    cursor: clickable ? "pointer" : "default",
    transformStyle: "preserve-3d" as const,
    transformOrigin: "center center",
    transition:
      "box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1), transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.25s ease",
    "@keyframes dashboardCardIn": {
      from: {
        opacity: 0,
        transform: "translateY(10px) rotateX(8deg) scale(0.97)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0) rotateX(0deg) scale(1)",
      },
    },
    animation: "dashboardCardIn 520ms cubic-bezier(0.22, 1, 0.36, 1) both",
    "&:hover": {
      boxShadow: dashboardCardHoverShadow,
      borderColor: accent || (clickable ? "#d2363a" : "#d1d5db"),
      transform: clickable
        ? "translateY(-7px) rotateX(5deg) rotateY(-3deg) scale(1.02)"
        : "translateY(-4px) rotateX(3deg) scale(1.01)",
    },
    "&:active": clickable
      ? {
          transform: "translateY(-2px) rotateX(2deg) scale(0.99)",
          boxShadow:
            "0 4px 12px rgba(210, 54, 58, 0.14), 0 2px 6px rgba(15, 23, 42, 0.08)",
        }
      : undefined,
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
      transition: "box-shadow 0.2s ease, border-color 0.2s ease",
      "&:hover": {
        transform: "none",
      },
      "&:active": {
        transform: "none",
      },
    },
  };
};
